export default "__VITE_ASSET__QmGTrYii__"